import React, { useEffect, useState, ChangeEvent } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faPlay, faClock } from '@fortawesome/free-solid-svg-icons'
import { connect } from 'react-redux'
import { Dispatch, AnyAction, bindActionCreators } from 'redux'
import { getAppParamters, updateAppParamters, saveAppParameters } from '../../store/actions/siteConfig'
import TextInput from '../../components/TextInput'
import { useHistory } from 'react-router'
import { get } from 'lodash';
import { IModulesPermissions } from '../../shared/models/rolesPermissionModel'
import { IAppParameter } from '../../shared/models/appParameterModel'
import BackButton from '../../components/BackButton'
import { MESSAGES } from '../../services/constants'

interface IProps {
  isLoading: boolean;
  permission: IModulesPermissions;
  appParameters: IAppParameter[];
  getAppParameterList: Function;
  updateAppParamterList: Function;
  saveAppParamterList: Function;
}

const SiteConfiguration = (props: IProps) => {

  useEffect(() => {
    props.getAppParameterList();
  }, [])

  const history = useHistory();
  const canEdit = get(props.permission.systemConfiguration, 'edit', false);
  const canAdd = get(props.permission.systemConfiguration, 'create', false);
  const [errorFieldIds, setErrorIds]: any[] = useState([]);

  const checkValidation = () => {
    let ids: any[] = errorFieldIds;
    let updatedErrorIds: any[] = ids;
    props.appParameters.map(item => {
      let index = errorFieldIds.findIndex(id => id === item.id)

      if (!item.hours) {

        if (index === -1) {
          ids.push(item.id)
          updatedErrorIds = ids;
        }
      } else {

        if (index >= 0) {
          updatedErrorIds = ids.slice(index, 1)
        }
      }
      return true;
    })
    setErrorIds(updatedErrorIds);
    return ids.length === 0;
  }

  const handleSave = () => {
    let isValid = checkValidation();
    if (isValid) props.saveAppParamterList(props.appParameters);
  }

  const handleChange = (value, param) => {
    let ids: any[] = errorFieldIds;
    let updatedErrorIds: any[] = ids;
    let index = ids.findIndex(id => id === param.id)

    if (!value || !value.trim() || value <= 0 || isNaN(value)) {
      if (index === -1) {
        ids.push(param.id)
        updatedErrorIds = ids;
      }
    } else {
      if (index >= 0) {
        updatedErrorIds = ids.slice(param.id, 1);
      }
    }
    setErrorIds(updatedErrorIds);
    props.updateAppParamterList(value, param)
  }

  return (
    <div className="container-fluid width-control">
      <div className="page-header">
        <h1>Site Configuration</h1>
        <BackButton />
        {canEdit && <button disabled={props.isLoading} type="button" className="btn btn-primary ml-auto" onClick={handleSave}>Save</button>}
      </div>

      <div className="page-content">
        <div className="row">
          <div className="col-md-12 width-control">
            <ul className="configuration-listing">
              {props.appParameters.map((param: any) => (
                <ConfigItem
                  error={errorFieldIds.indexOf(param.id) >= 0 ? MESSAGES.requiredField('Hour') : null}
                  key={param.id}
                  {...param}
                  canEdit={canEdit}
                  updateHours={(e: ChangeEvent<HTMLInputElement>) => handleChange(e.target.value, param)} ></ConfigItem>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

const ConfigItem = (props: any) => (
  <li className="box-shaddow">
    <div className="confi-wrap row">
      <div className="col-md-3">
        <span className="text-value">{props.fromColumnName}</span>
      </div>
      <div className="col-md-1 confi-icon">
        <FontAwesomeIcon icon={faPlay} />
      </div>
      <div className="col-md-5">
        <span className="text-value">{props.toColumnName}</span>
      </div>
      <div className="col-md-3">
        <div className="config-time confi-icon">
          <FontAwesomeIcon icon={faClock} className="mr-3" />
          <div>
            <TextInput
              disabled={!props.canEdit}
              className="form-control mr-2"
              value={props.hours}
              onChange={props.updateHours}
              error={props.error} />
          </div>
          hours
        </div>
      </div>
    </div>
  </li>
)

const mapStateToProps = (state: any) => ({
  isLoading: state.common.isLoading,
  permission: state.auth.user.permission,
  appParameters: state.config.appParameters
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
  getAppParameterList: bindActionCreators(getAppParamters, dispatch),
  updateAppParamterList: bindActionCreators(updateAppParamters, dispatch),
  saveAppParamterList: bindActionCreators(saveAppParameters, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(SiteConfiguration);
